<template>
    <section class="pt-66px flex flex-col items-center bg-Banner">
        <section class="py-52 flex flex-col items-center">
            <h1 class="text-3xl pb-8  font-semibold">LANDINGS REALIZADAS</h1>

            <section class="flex flex-row  w-full border-2 border-black bg-form rounded-2.5">
                <section class="py-6 w-80 h-88 border-r-2 border-black ">
                    <section class="border-b-2 border-black ">
                        <h2 class="font-semibold mb-3">NOMBRE DEL COMPONENTE</h2>

                    </section>
                    <ul class="gap-y-6 px-8 pt-6 flex flex-col text-center">
                        <li >
                            
                            <router-link v-text="'10-Obstaculos'" to="/landing/10-obstaculos"/>
                        </li>
                        <li>
                            <router-link v-text="'telemedicina-diabetes'" to="/landing/telemedicina-diabetes"/>
                        </li>
                    </ul>
                </section>

                <section class="py-6 w-80 h-88 ">
                    <section class="border-b-2 border-black ">
                        <h2 class="font-semibold  mb-3">PATH DEL COMPONENTE</h2>

                    </section>
                    <section class="gap-y-6 px-8 pt-6 text-center flex flex-col">
                      
                        <router-link v-text="'/landing/10-obstaculos'" to="/landing/10-obstaculos"/>
                        
                        <router-link v-text="'/landing/telemedicina-diabetes'" to="/landing/telemedicina-diabetes"/>
                      

                    </section>

                </section>
            </section>
        </section>
    </section>
</template>

<script>
export default {
    
}
</script>